// extracted by mini-css-extract-plugin
export default {"container":"RadioBtn_container__oHMjK","label":"RadioBtn_label__TiPtb","radio":"RadioBtn_radio__9QDf4"};